import React, { useContext } from 'react';
import { context } from '../../../context';
import { Anchor, Margin, Hr } from '../../atoms';
import { NoReview, RatingAverage, RatingDistribution, TypeOfReview } from '../../molecules';
import { HeaderContainer, DataWrapper, RatingsContainer, Text } from './Styled';

const Head = (props: any) => {
  const { dispatchMetrics } = props;
  const { data, config } = useContext(context);
  const { totalReviews } = data;
  const { productId } = config;
  const href = `/avaliacao/${productId}`;
  const anchorMetric = () => {
    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'avaliar-produto',
      label: 'area-avaliacao',
    });
  };

  if (!totalReviews) {
    return <NoReview />;
  }

  return (
    <HeaderContainer>
      <DataWrapper>
        <Anchor href={href} onClick={anchorMetric}>
          avaliar produto
        </Anchor>
        <Margin bottom={20} />
        <RatingsContainer>
          <RatingAverage />
          <Text>filtrar por</Text>
          <RatingDistribution dispatchMetrics={dispatchMetrics} />
        </RatingsContainer>
        <Margin bottom={20} />
        <Hr />
      </DataWrapper>
      <TypeOfReview />
    </HeaderContainer>
  );
};

const Header = React.memo(Head);

export default Header;
export { Header };
